export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/geometric.c97827f.svg";